import { useMemo } from 'react';
import { useGetGolfEventSummaryQuery } from '../state/api';
import { selectAllEvents } from '../state/entitySelectors';
import { useAppSelector } from '../hooks/reduxHooks';
import OtherCompOverview from './other-comp-overview';

const OtherCompOverviewContainer = () => {
  // Fetch data with RTK Query
  useGetGolfEventSummaryQuery();

  // Use entity selector for optimized access to normalized data
  const events = useAppSelector(selectAllEvents);

  // Filter for non-Summer Tour events (could be moved to a custom selector if used often)
  const lstEvents = useMemo(() => events.filter((event) => event.series !== 'Summer Tour'), [events]);

  return <OtherCompOverview lstEvents={lstEvents} />;
};

export default OtherCompOverviewContainer;
